import VueRouter, { RouteConfig } from 'vue-router'
import IndexPage from '@/views/my-gift/Index.vue'
import GiftDetailPage from '@/views/my-gift/GiftDetail.vue'
import SelectMyGiftAddressPage from '@/views/my-gift/SelectMyGiftAddress.vue'
import MyGiftAddressPage from '@/views/my-gift/MyGiftAddress.vue'
import AddOrEditAddressComp from '@/views/my-gift/AddOrEditAddress.vue'
import ActivityAddressConfirm from '@/views/my-gift/ActivityAddressConfirm.vue'
import { ITeacherAddressInfo } from 'kuaidong-model'
export const myGiftRoute: RouteConfig = {
  path: '/my-gift',
  name: 'my_gift',
  component: IndexPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的礼品',
  },
}

export const giftDetailRoute: RouteConfig = {
  path: '/gift-detail',
  name: 'gift_detail',
  component: GiftDetailPage,
  props: (route) => ({ ...route.query, ...route.params }),

  meta: {
    title: '礼品详情',
  },
}

export const selectMyGiftAddressPageRoute: RouteConfig = {
  path: '/select-my-gift-address',
  name: 'select_my_gift_address',
  component: SelectMyGiftAddressPage,
  props: (route) => ({ ...route.query, ...route.params, addressInfo: JSON.parse(route.query.addressInfo as string) }),
  meta: {
    title: '我的收货地址',
  },
}

export const myGiftAddressPageRoute: RouteConfig = {
  path: '/my-gift-address',
  name: 'my_gift_address',
  component: MyGiftAddressPage,
  meta: {
    title: '我的收货地址',
  },
}

export const addGiftAddressPageRoute: RouteConfig = {
  path: '/add-gift-address',
  name: 'add_gift_address',
  component: AddOrEditAddressComp,
  props: (route) => ({
    ...route.query,
    ...route.params,
    addressInfo: route.query.addressInfo ? JSON.parse(route.query.addressInfo as string) : undefined,
  }),
  meta: {
    title: '添加收货地址',
  },
}

export const confirmGiftAddressPageRoute: RouteConfig = {
  path: '/confirm-gift-address',
  name: 'confirm_gift_address',
  component: ActivityAddressConfirm,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '确认收货地址',
  },
}

export default [
  myGiftRoute,
  giftDetailRoute,
  selectMyGiftAddressPageRoute,
  addGiftAddressPageRoute,
  myGiftAddressPageRoute,
  confirmGiftAddressPageRoute,
]

export function navigateToGiftAddressConfirm(
  router: VueRouter,
  addressId: string,
  options: {
    bannerUrl?: string
    caption?: string
  }
) {
  router.push({
    name: confirmGiftAddressPageRoute.name,
    params: {
      addressId,
      ...options,
    },
  })
}

export function navigateToGiftAddressEdit(router: VueRouter, address: ITeacherAddressInfo) {
  router.push({
    name: addGiftAddressPageRoute.name,
    query: {
      addressInfo: JSON.stringify(address),
    },
  })
}
